import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  sliderContainer: {
    padding: "200px",
    background:
      "linear-gradient(to right, rgba(0,152,219,0.3) 0%,rgba(0,152,219,0.31) 1%,rgba(255,255,255,0.65) 50%,rgba(255,255,255,1) 100%)",
    backgroundColor: "#ebebeb",
    [theme.breakpoints.down("xs")]: {
      paddingLeft: "6px",
      paddingRight: "0",
      paddingTop: "30px",
      paddingBottom: "30px",
      background:
        "linear-gradient(to left, rgba(0, 152, 219, 0) 0%, rgba(0, 152, 219, 0.3) 70%)",
      backgroundColor: "white",
      display: "flex",
      overflowX: "scroll"
    }
  },
  sliderSlick: {
    "& .slick-active": {
      width: "260px !important",
      maxWidth: "260px",
      marginRight: "15px",
      marginLeft: "10px"
    },
    "& .slick-active .MuiPaper-root": {
      boxShadow:
        "0 3px 5px -1px rgba(0, 0, 0, 0.2), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14)"
    },
    "& .slick-track": {
      // transform: "translate3d(-260px, 0px, 0px) !important"
    }
  }
}));

export default styles;
